
























import { Component, Prop, Vue } from 'vue-property-decorator';
import {successButtonColorClass} from '@/utlitities/color';
import {UserStore} from '@/store/user-module';

@Component({
  components: {
  },
})
export default class MainMenuItem extends Vue {
  private visible: boolean = false;
  @Prop() type!: string;
  @Prop() icon!: string;
  @Prop() to!: string;
  @Prop() activeGroup!: string;

  get successButtonColor(){
    return successButtonColorClass(UserStore.userSettings.successButtonColor)
  }

  get isActive() {
    let currentRoute = this.$route.path;

    if (!this.to) return false;

    if (this.to == '/') return currentRoute == this.to;

    return currentRoute.toLowerCase().startsWith(this.to.toLowerCase());
  }
}
